export const getTrack = (lang: string) => {
  const ukrDays = [
      'Неділя',
      'Понеділок',
      'Вівторок',
      'Середа',
      'Четвер',
      "П'ятниця",
      'Субота',
    ],
    ruDays = [
      'Воскресенье',
      'Понедельник',
      'Вторник',
      'Среда',
      'Четверг',
      'Пятница',
      'Суббота',
    ],
    enDays = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ]

  const ukrError = {
      icon:
        'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/errorpackage.svg',
      text:
        'Ми не знайшли посилку за таким номером. Можливо, вона ще не передана для відправлення, або номер некоректний. Перевірте, чи відповідає вказаний номер можливому формату: 59500000031324 або AENM0002497278NPI.',
    },
    enError = {
      icon:
        'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/errorpackage.svg',
      text:
        'We did not find a parcel with this number. It may not have been shipped yet, or the number may be incorrect. Please check, if the number you have entered looks like this: 59500000031324 or AENM0002497278NPI.',
    },
    ruError = {
      icon:
        'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/errorpackage.svg',
      text:
        'Мы не нашли посылку по такому номеру. Возможно, она еще не передана для отправки или номер некорректен. Проверьте, соответствует ли указанный номер формату: 59500000031324 или AENM0002497278NPI.',
    }

  const ukrMonths = [
      'Січня',
      'Лютого',
      'Березня',
      'Квітня',
      'Травня',
      'Червня',
      'Липня',
      'Серпня',
      'Вересня',
      'Жовтня',
      'Листопада',
      'Грудня',
    ],
    ruMonths = [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ],
    enMonths = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'Noverber',
      'December',
    ]

  const ukrBanners = [
      {
        link: 'https://aliexpert.com.ua',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/banners-npg-tracking6.jpg',
      },
      {
        link: 'https://ua.iherb.com/',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/banners-npg-tracking2.jpg',
      },
      {
        link: 'https://www.alensa.ua',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/banners-npg-tracking7.jpg',
      },
      {
        link: 'https://www.joom.com/uk',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/banners-npg-tracking10.jpg',
      },
      {
        link: 'https://npshopping.com/',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/09/shopping-ua.png',
      },
      {
        link: 'https://preprod.novaposhtaglobal.com/for-you/#globalna-dostavka',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/09/send-ua.png',
      },
    ],
    enBanners = [
      {
        link: 'https://aliexpert.com.ua',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/banners-npg-tracking5.jpg',
      },
      {
        link: 'https://ua.iherb.com/',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/banners-npg-tracking1.jpg',
      },
      {
        link: 'https://www.alensa.ua',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/banners-npg-tracking9.jpg',
      },
      {
        link: 'https://www.joom.com/uk',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/banners-npg-tracking12.jpg',
      },
      {
        link: 'https://npshopping.com/',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/09/shopping-en-1.png',
      },
      {
        link: 'https://preprod.novaposhtaglobal.com/for-you/#globalna-dostavka',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/09/send-en.png',
      },
    ],
    ruBanners = [
      {
        link: 'https://aliexpert.com.ua',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/banners-npg-tracking4.jpg',
      },
      {
        link: 'https://ua.iherb.com/',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/banners-npg-tracking3.jpg',
      },
      {
        link: 'https://www.alensa.ua',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/banners-npg-tracking8.jpg',
      },
      {
        link: 'https://www.joom.com/uk',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/07/banners-npg-tracking11.jpg',
      },
      {
        link: 'https://npshopping.com/',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/09/shopping-ru.png',
      },
      {
        link: 'https://preprod.novaposhtaglobal.com/for-you/#globalna-dostavka',
        src:
          'https://preprod.novaposhtaglobal.com/wp-content/uploads/2022/09/send-ru.png',
      },
    ]
  return {
    backgroundImg: lang.includes('En')
      ? null
      : lang.includes('ру')
      ? null
      : null,
    bill: {
      title: lang.includes('En')
        ? 'Parcel tracking number'
        : lang.includes('ру')
        ? 'Экспресс-накладная посылки №'
        : 'Експрес-накладна посилки №',
      share: lang.includes('En')
        ? 'Share'
        : lang.includes('ру')
        ? 'Поделиться'
        : 'Поширити',
      copy: lang.includes('En')
        ? 'Link copied'
        : lang.includes('ру')
        ? 'Ссылка скопирована'
        : 'Посилання скопійовано',
    },
    buttonTitle: lang.includes('En')
      ? 'Track'
      : lang.includes('ру')
      ? 'Отследить'
      : 'Відстежити',
    dateEnd: lang.includes('En') ? '' : lang.includes('ру') ? 'г.' : 'р.',
    days: lang.includes('En') ? enDays : lang.includes('ру') ? ruDays : ukrDays,
    error: lang.includes('En')
      ? enError
      : lang.includes('ру')
      ? ruError
      : ukrError,
    imgs: null,
    history: {
      title: lang.includes('En')
        ? 'Search history'
        : lang.includes('ру')
        ? 'История поиска'
        : 'Історія пошуку',
      clear: lang.includes('En')
        ? 'Clear history'
        : lang.includes('ру')
        ? 'Очистить историю'
        : 'Очистити історію',
      clearMob: lang.includes('En')
        ? 'Clear history'
        : lang.includes('ру')
        ? 'Очистить'
        : 'Очистити',
    },
    mobTitle: lang.includes('En')
      ? 'Enter the parcel number'
      : lang.includes('ру')
      ? 'Введите номер посылки'
      : 'Введіть номер посилки',
    months: lang.includes('En')
      ? enMonths
      : lang.includes('ру')
      ? ruMonths
      : ukrMonths,
    statuses: {
      title: lang.includes('En')
        ? 'Status history'
        : lang.includes('ру')
        ? 'История статусов'
        : 'Історія статусів',
    },
    today: lang.includes('En')
      ? 'Today'
      : lang.includes('ру')
      ? 'Сегодня'
      : 'Сьогодні',
    title: lang.includes('En')
      ? 'Enter the parcel number'
      : lang.includes('ру')
      ? 'Введите номер посылки'
      : 'Введіть номер посилки',
  }
}

// lang.includes('En')
//       ? enBanners
//       : lang.includes('ру')
//       ? ruBanners
//       : ukrBanners,
